module.exports = __webpack_public_path__ + "img/safety-icon-01.62eceae8.gif";